import { get, post, put, del } from "./ApiService";

export const getAllProjects = async () => {
  const response = await get("/projects");
  return response.projects || [];
};

export const addProject = async (projectData) => {
  const response = await post("/projects", projectData);
  return response;
};

export const getProjectMembers = async (projectId) => {
  const response = await get(`/projects/${projectId}/members`);
  return response.members || [];
};

export const removeMemberFromProject = async (projectId, userId) => {
  const payload = {
    project_id: projectId,
    uniq: projectId,
    uniq_id: projectId,
    user_id: userId,
    member_id: userId
  };
  const attempts = [
    () => del(`/projects/${projectId}/members/${userId}`, payload),
    () => del("/project_users", payload),
    () => del("/projects", payload)
  ];

  let lastError = null;

  for (const attempt of attempts) {
    const response = await attempt();
    if (response && response.status !== "error") {
      return response;
    }
    lastError = response;
  }

  throw new Error(lastError?.message || "Kullanıcı projeden çıkarılamadı.");
};

export const updateProjectMemberRole = async (projectId, userId, role) => {
  const normalizedRole = String(role || "").trim().toLowerCase() === "manager" ? "manager" : "member";
  const response = await put(`/projects/${projectId}/members/${userId}`, {
    role: normalizedRole === "manager" ? "admin" : "member",
    member_role: normalizedRole,
    is_admin: normalizedRole === "manager" ? 1 : 0,
    is_manager: normalizedRole === "manager" ? 1 : 0
  });

  if (response?.status === "error") {
    throw new Error(response.message);
  }

  return response;
};
